export default __webpack_public_path__ + "static/media/duda.7ff9b4ca.png";